import React, {useEffect, useRef, useState} from "react";
import {useSubheader} from "../../../_metronic/layout";
import {Checkbox, Paper, Table, TableBody, TableCell, TablePagination, TableRow, TextField} from "@material-ui/core";
import {Button, Dropdown} from "react-bootstrap";
import EnhancedTableHead from "../../components/EnhancedTableHead";
import makeRequest from "../../api/makeRequest";
import {Link} from "react-router-dom";
import {DashboardUserMenu, DropdownCustomToggler} from "../../../_metronic/_partials/dropdowns";
import {useTranslation} from "react-i18next";

export const UsersPage = () => {

	const { t } = useTranslation('common');
	const headRows = [
		{id: "id", disablePadding: true, label: t('Id')},
		{id: "name", disablePadding: false, label: t('Name')},
		{id: "username", disablePadding: false, label: t('AUTH.INPUT.USERNAME')},
		// {id: "service_name", disablePadding: false, label: "سرویس"},
		// {id: "active", disablePadding: false, label: "فعال/غیرفعال"}
		{id: "operation", disablePadding: false, label: t('Operations')},
	];
	const suhbeader = useSubheader();
	suhbeader.setTitle(t('Users'));

	const [selected, setSelected] = React.useState([]);
	const [orderBy, setOrderBy] = React.useState("id");
	const [order, setOrder] = React.useState("desc");
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);
	const [totalDocs, setTotalDocs] = React.useState(0);

	const [Users, setUsers] = useState([])

	const [search,setSearch] = useState({})
	const [requestSearch,setRequestSearch] = useState(false)

	useEffect(() => {
		const getUsers = async () => {
			try {
				const query = {
					page:page+1,
					per_page:rowsPerPage
				}
				const {data} = await makeRequest('getUsers', {search},query)
				const users = data.users.docs
				setUsers(users)
				setTotalDocs(data.users.totalDocs)
			} catch (e) {
				console.log(e)
			}
		}

		getUsers()
	}, [page,rowsPerPage,requestSearch])

	function handleSelectAllClick(event) {
		if (event.target.checked) {
			const newSelecteds = Users.map(n => n.name);
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	}

	function handleRequestSort(event, property) {
		const isDesc = orderBy === property && order === "desc";
		setOrder(isDesc ? "asc" : "desc");
		setOrderBy(property);
	}


	function stableSort(array, cmp) {
		const stabilizedThis = array.map((el, index) => [el, index]);
		stabilizedThis.sort((a, b) => {
			const order = cmp(a[0], b[0]);
			if (order !== 0) return order;
			return a[1] - b[1];
		});
		return stabilizedThis.map(el => el[0]);
	}

	function desc(a, b, orderBy) {
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	}

	function getSorting(order, orderBy) {
		return order === "desc"
			? (a, b) => desc(a, b, orderBy)
			: (a, b) => -desc(a, b, orderBy);
	}

	const isSelected = name => selected.indexOf(name) !== -1;

	function handleClick(event, name) {
		const selectedIndex = selected.indexOf(name);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, name);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1)
			);
		}

		setSelected(newSelected);
	}

	const emptyRows =
		rowsPerPage - Math.min(rowsPerPage, Users.length - page * rowsPerPage);

	function handleChangePage(event, newPage) {
		setPage(newPage);
	}

	function handleChangeRowsPerPage(event) {
		setPage(0)
		setRowsPerPage(parseInt(event.target.value, 10));
	}

	return (
		<>
			<div className="new-user">
				<Link to={'/user/new'}><Button variant="outline-primary mb-5">{t('MENU.NEW')}</Button></Link>
				<Link to={'/user/import'}><Button variant="outline-primary mx-5 mb-5">{t('MENU.EXCEL_IMPORT')}</Button></Link>
			</div>
			<SearchInputs
				onSearch={(e)=>{
					setSearch(e)
					setRequestSearch(prev=>!prev)
				}}
				showReset={JSON.stringify(search) !== "{}"}
			/>
			<Paper className={"classes.paper"}>
				<div className={"tableWrapper"}>
					<Table
						className={"classes.table"}
						aria-labelledby="tableTitle"
						size={"medium"}
					>
						<EnhancedTableHead
							numSelected={selected.length}
							order={order}
							orderBy={orderBy}
							onSelectAllClick={handleSelectAllClick}
							onRequestSort={handleRequestSort}
							rowCount={Users.length}
							headRows={headRows}
						/>
						<TableBody>
							{stableSort(Users, getSorting(order, orderBy))
								.map((row, index) => {
									const isItemSelected = isSelected(row.id);
									const labelId = `enhanced-table-checkbox-${index}`;

									return (
										<TableRow
											hover
											onClick={event => handleClick(event, row.id)}
											role="checkbox"
											aria-checked={isItemSelected}
											tabIndex={-1}
											key={row.id}
											selected={isItemSelected}
										>
											<TableCell padding="checkbox">
												<Checkbox
													checked={isItemSelected}
													inputProps={{
														"aria-labelledby": labelId
													}}
												/>
											</TableCell>
											<TableCell
												component="th"
												id={labelId}
												align="right"
											>
												{row.id}
											</TableCell>
											<TableCell align="right">{row.name}</TableCell>
											<TableCell align="right">{row.username}</TableCell>
											{/*<TableCell align="right">{row.service_name}</TableCell>*/}
											{/*<TableCell align="right">{row.active ? 'بله' : 'خیر'}</TableCell>*/}
											<TableCell align="right"><ItemDropdown item={row} onDelete={()=>{
												setUsers(prev=>prev.filter(q=>q.id !== row.id))
											}}/></TableCell>
										</TableRow>
									);
								})}
							{emptyRows > 0 && (
								<TableRow style={{height: 49 * 5}}>
									<TableCell colSpan={6}/>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</div>
				<TablePagination
					rowsPerPageOptions={[5, 10, 25, 50, 100]}
					component="div"
					labelRowsPerPage={t('NumberPerPage')}
					count={totalDocs}
					rowsPerPage={rowsPerPage}
					page={page}
					backIconButtonProps={{
						"aria-label": "Previous Page"
					}}
					nextIconButtonProps={{
						"aria-label": "Next Page"
					}}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
				/>
			</Paper>
		</>
	);
};
const ItemDropdown = ({item,onDelete}) => {
	return (<>
		<Dropdown className="dropdown-inline" alignRight>
			<Dropdown.Toggle
				id="dropdown-toggle-top"
				as={DropdownCustomToggler}>
				<i className="ki ki-bold-more-hor"/>
			</Dropdown.Toggle>
			<Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
				<DashboardUserMenu item={item} onDelete={onDelete}/>
			</Dropdown.Menu>
		</Dropdown>
	</>);
};

const SearchInputs = React.memo(({onSearch,showReset=false})=>{
	const [name,setName] = useState('')
	const [username,setUsername] = useState('')
	const [id,setId] = useState('')
	const { t } = useTranslation('common');
	return(
		<div className='flex justify-content-between align-items-center my-5'>
			<form  onSubmit={(e)=> {
				e.preventDefault()
				onSearch({name, username, id})
			}}>
				<TextField onChange={(e)=>setName(e.target.value)} className='mx-2 my-2' label={t('Name')} variant="outlined"/>
				<TextField onChange={(e)=>setUsername(e.target.value)} className='mx-2 my-2' label={t('AUTH.INPUT.USERNAME')} variant="outlined"/>
				<TextField onChange={(e)=>setId(e.target.value)} className='mx-2 my-2' label={t('Id')} variant="outlined"/>
				<Button type='submit' className='mx-2 my-2' style={{lineHeight:"2.6"}}>{t('ECOMMERCE.COMMON.SEARCH')}</Button>
				{showReset ? <Button type='reset' onClick={()=>onSearch({})} className='mx-2 my-2' style={{lineHeight:"2.6"}} variant="outline-danger">{t('RemoveFilter')}</Button> : null}
			</form>

		</div>
	)
})